<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const PRODUCT_PROMOTION_CLICK = analyticsUtilities.events.PRODUCT_PROMOTION_CLICK;

	module.exports = {
		components: {
			'step-icon': require('components/svg/step-icon.vue').default,
			'ebook-icon': require('components/svg/ebook-icon.vue').default,
			'speaker-icon': require('components/svg/speaker-icon.vue').default,
			'pencil-icon': require('components/svg/pencil-icon.vue').default
		},
		props: {
			applyFilters: {
				default: function () {
					return;
				}
			}
		},
		modelData: ['gcAddon'],
		methods: {
			filterByArticle(filters, loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
				this.applyFilters(...filters);
			},
			onBlurbTextClick(loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.promotion-panel.article {
		.speaker-icon path.speaker-icon-fill {
			fill: $c-white;
		}

		button.article-feature.button:hover {
			polygon,
			path {
				fill: $c-white;
			}
		}
	}
</style>
<template>
	<div class="promotion-panel product-promotion-panel article">
		<div class="promotion-title">
			<h2>Reading Passages</h2>
			<a
				href="javascript:void(0)"
				@click="filterByArticle([{ id: 'A' }], 'ARTICLE_BROWSE')"
				>See All <i class="fa-solid fa-arrow-right-long"></i
			></a>
		</div>
		<div class="promotion-blurb">
			Personalize instruction for every student by selecting from 1000s of
			<a
				href="/teacher-guide/reading-passages.html"
				:target="gcAddon ? '_blank' : '_self'"
				@click="onBlurbTextClick('passages-promo-tg')"
				>nonfiction and fiction passages</a
			>
			and adding one (or all!) of our research-based supports. You can also add passages to science and social studies units to increase reading
			practice.
		</div>
		<div class="article-features">
			<div class="feature-row">
				<button
					class="article-feature button -small -outline"
					@click="
						filterByArticle(
							[{ id: 'full' }, { id: 'express' }, { id: 'writing' }, { id: 'inferring' }, { id: 'monitoring' }, { id: 'text_structure' }],
							'ARTICLE_ACTIVITIES'
						)
					">
					<pencil-icon></pencil-icon>
					Question Sets
				</button>
				<button
					class="article-feature button -small -outline"
					@click="filterByArticle([{ id: 'S' }, { id: 'A' }], 'ARTICLE_STEPREADS')">
					<step-icon></step-icon>
					StepReads™
				</button>
				<button
					class="article-feature button -small -outline"
					@click="filterByArticle([{ id: 'EBOOK' }, { id: 'A' }], 'ARTICLE_EBOOK')">
					<ebook-icon></ebook-icon>
					eBooks
				</button>
			</div>
		</div>
	</div>
</template>
